import { clsx } from '../../../lib/clsx';

import styles from './Heading3Medium.module.css';

import type { HeadingProps } from './text.types';

export function Heading3Medium(props: HeadingProps) {
  const { lineHeight, color, textAlign, className, style, children, ...rest } = props;

  return (
    <h3
      {...rest}
      className={clsx(styles.root, className)}
      style={{
        '--prop-line-height': lineHeight,
        '--prop-color': color,
        ...style,
      }}
      data-text-align={textAlign}
    >
      {children}
    </h3>
  );
}
